if (!customElements.get('wf-3d-views')) {
  // Targets measured from the current models' display/battery geometry, then visually checked.
  const cameraProfiles={"wf-ootd-3d":{"display":[-0.287,1.2985272,0],"frame":[-0.40,0.34,0]},"product-model":{"display":[-0.3867,1.1645,0.0028],"battery":[0.1527,0.5489,0.0]},"wf-engwe-3d":{"display":[-0.3433,1.2405,-0.0728],"battery":[-0.045,0.582,0.052]},"wf-koolux-3d":{"display":[-0.2025,1.2004,0.164],"battery":[0.2468,0.4749,0.0]},"wf-x9-3d":{"display":[-0.3152,1.0507,0.0],"battery":[-0.0764,0.5174,0.0]},"wf-l20-3d":{"display":[-0.3614,1.1654,0.2164],"battery":[0.23,0.5935,0.0]},"wf-x15-3d":{"display":[-0.3347,1.1049,0.1303],"battery":[-0.045,0.5984,0.0]},"wf-falcon-3d":{"display":[-0.3481,1.0754,0.0],"battery":[-0.1143,0.6241,0.0]},"wf-x10-3d":{"display":[-0.3594,1.0534,0.106],"battery":[0.235,0.4514,0.0]},"wf-engine-3d":{"display":[-0.3404,1.2485,-0.0728],"battery":[-0.045,0.5832,0.0505]},"wf-f26-3d":{"display":[-0.5094,1.1504,0.0],"battery":[-0.1983,0.5965,0.0]},"wf-nt5-3d":{"display":[-0.252,1.3341,0.0]},"wf-nanrobot-h1-3d":{"display":[-0.2381,1.0388,0.0],"frame":[-0.3673845808953047,0.33571869134902954,0.0]},"wf-j15-3d":{"display":[-0.2995,1.347,0.0]},"wf-g3-3d":{"display":[-0.2081,1.2517,-0.0023]},"wf-kukirin-g2-3d":{"display":[-0.2492,1.2008,-0.0084]},"wf-ix7-3d":{"display":[-0.1705,1.2603,0.0]}};
  customElements.define('wf-3d-views', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.buttons = [...this.querySelectorAll('[data-view]')];
      const signal = this.controller.signal;
      this.mobileSelect=this.querySelector('[data-mobile-view]');
      this.mobileSelect?.addEventListener('change',()=>{if(this.mobileSelect.value!=="free")this.select(this.mobileSelect.value)},{signal});
      this.tourButton=this.querySelector('[data-tour]');
      this.tourButton?.addEventListener('click',()=>this.toggleTour(),{signal});
      if(this.isOrbitTour()){
        this.initOrbitUI();
        this.reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
        this.reducedMotion.addEventListener('change',()=>{this.stopTour();this.updateTourButton()},{signal});
        this.updateTourButton();
      }
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.stopTour()},{signal});
      this.helpPanel=this.querySelector('.wf-camera-info');
      this.helpPanel?.addEventListener('toggle',()=>{if(this.helpPanel.open)this.helpPanel.querySelector('summary')?.focus()},{signal});
      this.addEventListener('pointerup', e => e.stopPropagation(), {signal});
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(button.dataset.view), {signal}));
      this.host = this.parentElement;
      this.host.addEventListener('click',e=>{if(e.target.closest('[data-colour]'))this.stopTour()},{capture:true,signal});
      this.fullscreenHost=this.host.closest('dialog,product-modal') || this.host;
      this.fullscreenSurface=this.fullscreenHost;
      document.addEventListener('fullscreenchange',()=>{if(this.nativeFullscreen&&document.fullscreenElement!==this.fullscreenSurface){this.nativeFullscreen=false;this.setExpanded(false)}},{signal});
      this.fullscreenHost.addEventListener('close',()=>{this.stopTour();this.exitFullscreen();if(this.helpPanel)this.helpPanel.open=false},{signal});
      this.fullscreenHost.addEventListener('keydown',e=>{if(e.key==='Escape'&&this.expanded&&!document.fullscreenElement){e.preventDefault();e.stopPropagation();this.exitFullscreen()}},{capture:true,signal});
      this.closeObserver=new MutationObserver(()=>{if(this.fullscreenHost.getAttribute('aria-hidden')==='true'||(this.fullscreenHost.matches('dialog,product-modal')&&!this.fullscreenHost.hasAttribute('open'))){this.stopTour();if(this.expanded)this.exitFullscreen();if(this.fullscreenHost.matches('product-modal')){this.host.classList.remove('wf-standard-panel');this.host.querySelector('.wf-standard-stage')?.classList.remove('wf-standard-stage')}}else if(this.viewer&&this.fullscreenHost.matches('product-modal.wf-c6-3d-view'))this.applyStandardLayout(this.viewer)});this.closeObserver.observe(this.fullscreenHost,{attributes:true,attributeFilter:['aria-hidden','open']});
      this.observer = new MutationObserver(() => this.bind());
      this.observer.observe(this.host, {childList:true, subtree:true});
      this.bind();
    }
    disconnectedCallback() { this.stopTour(); this.a11yObserver?.disconnect(); this.controller?.abort(); this.controller=null; this.observer?.disconnect(); this.resizeObserver?.disconnect(); this.tools?.remove(); this.closeObserver?.disconnect();this.exitFullscreen(); }
    bind() {
      const viewer = this.host.querySelector('model-viewer');
      if (this.viewer === viewer) return;
      this.stopTour();this.resizeObserver?.disconnect(); this.tools?.remove();
      this.viewer=viewer;this.center=null;
      if(this.tourButton)this.tourButton.disabled=true;
      this.buttons.forEach(b=>b.disabled=true);
      if(this.mobileSelect)this.mobileSelect.disabled=true;
      this.a11yObserver?.disconnect();
      if (!viewer) return;
      this.applyStandardLayout(viewer);
      this.configureLighting(viewer);
      this.localizeViewer(viewer);
      this.initial={orbit:viewer.getAttribute('camera-orbit') || '-25deg 78deg 95%',target:viewer.getAttribute('camera-target') || 'auto auto auto',fov:viewer.getAttribute('field-of-view') || 'auto'};
      const ready=()=>{ if(this.viewer!==viewer) return; this.center ||= viewer.getCameraTarget(); this.initial.angles=viewer.getCameraOrbit(); this.initial.fovDegrees=viewer.getFieldOfView();
        const angles=this.initial.orbit.split(/\s+/);for(const [i,key] of [[0,'theta'],[1,'phi']]){if(/^-?[\d.]+(?:deg|rad)$/.test(angles[i]))this.initial.angles[key]=parseFloat(angles[i])*(angles[i].endsWith('deg')?Math.PI/180:1);}
        viewer.setAttribute("orbit-sensitivity","0.7"); viewer.setAttribute("touch-action","none");
        const size=viewer.getDimensions(); this.minRadius=Math.max(size.x,size.y,size.z)*.18; this.maxRadius=Math.max(size.x,size.y,size.z)*6;
        viewer.setAttribute("min-camera-orbit",`auto 10deg ${this.minRadius}m`);viewer.setAttribute("max-camera-orbit",`auto 170deg ${this.maxRadius}m`);
        this.addTools();this.configureColourLabel();if(this.tourButton)this.tourButton.disabled=false; this.buttons.forEach(b=>b.disabled=false); if(this.mobileSelect)this.mobileSelect.disabled=false;
        const help=this.querySelector('[data-camera-help]');
        if(help)help.textContent=[...this.host.querySelectorAll('p[class$="-hint"],p[class$="-note"],.wf-c6-model-hint,.wf-c6-model-disclaimer')].map(p=>p.textContent.trim()).join(' ');
        this.select('all');
        let rect=viewer.getBoundingClientRect();
        this.resizeObserver?.disconnect();
        this.resizeObserver=new ResizeObserver(()=>{const next=viewer.getBoundingClientRect();const changed=Math.abs(next.width-rect.width)>1||Math.abs(next.height-rect.height)>1;rect=next;if(changed)this.updateOrbitStatus();if(changed&&this.activeKey!=='free'&&next.height>0)this.select(this.activeKey||'all',true)});this.resizeObserver.observe(viewer); };
      viewer.addEventListener('load', ready, {signal:this.controller.signal});
      viewer.addEventListener('pointerdown',()=>this.stopTour(),{signal:this.controller.signal});
      viewer.addEventListener('keydown',()=>this.stopTour(),{signal:this.controller.signal});
      viewer.addEventListener('wheel',()=>this.stopTour(),{passive:true,signal:this.controller.signal});
      viewer.addEventListener('error', ()=>{this.stopTour();if(this.tourButton)this.tourButton.disabled=true;this.buttons.forEach(b=>b.disabled=true);if(this.mobileSelect)this.mobileSelect.disabled=true;}, {signal:this.controller.signal});
      viewer.addEventListener('camera-change', e=>{ this.updateZoomButtons();if(e.detail?.source==='user-interaction') {this.stopTour();this.zoomGoalRadius=null;this.updateZoomButtons();this.mark('free');} }, {signal:this.controller.signal});
      if (viewer.loaded) ready();
    }
    applyStandardLayout(viewer) {
      this.fullscreenHost.classList.add('wf-standard-modal');
      this.host.classList.add('wf-standard-panel');
      const stage=this.host.querySelector('[data-stage]')||viewer.closest('product-model')||viewer.parentElement;
      stage.classList.add('wf-standard-stage');
      let header=this.host.querySelector(':scope > [class$="-header"],:scope > .wf-standard-header');
      if(!header&&this.fullscreenHost.matches('product-modal')){
        header=document.createElement('div');header.className='wf-standard-header';
        const title=document.createElement('h2');title.textContent='DYU C6 · 3D';
        const original=this.fullscreenHost.querySelector('.product-media-modal__toggle');
        const close=document.createElement('button');close.type='button';close.textContent='×';close.dataset.close='';close.setAttribute('aria-label',original.getAttribute('aria-label'));
        close.addEventListener('click',()=>original.click(),{signal:this.controller.signal});
        header.append(title,close);this.host.prepend(header);
        if(document.activeElement===original)close.focus({preventScroll:true});
      }
      header?.classList.add('wf-standard-header');
    }
    configureColourLabel() {
      const locale=(document.documentElement.lang||'en').split('-')[0];
      const text={sv:'3D-färg – endast visning',en:'3D colour — viewing only',de:'3D-Farbe – nur Ansicht',fr:'Couleur 3D – aperçu uniquement',es:'Color 3D – solo visualización',it:'Colore 3D – solo visualizzazione'}[locale]||'3D colour — viewing only';
      this.host.querySelectorAll('[role=group]').forEach(group=>{
        if(!group.querySelector('[data-colour]'))return;
        group.classList.add('wf-standard-colours');group.setAttribute('aria-label',text);
        let label=group.querySelector(':scope > span');
        if(!label){label=document.createElement('span');group.prepend(label)}
        label.classList.add('wf-colour-purpose');label.textContent=text;
      });
    }
    configureLighting(viewer) {
      // Same fixed studio environment as the approved M20 pilot, in every view.
      viewer.setAttribute('environment-image','https://cdn.shopify.com/s/files/1/0513/1698/1950/files/engwe-m20-studio-side-v2-20261003.hdr');
      viewer.setAttribute('interaction-prompt','none');
      viewer.setAttribute('exposure','1.1');
      viewer.setAttribute('shadow-intensity','.85');
      viewer.setAttribute('shadow-softness',this.closest('[data-model-layout="falcongt"],[data-model-layout="lynx"]')?'.20':'.7');
    }
    localizeViewer(viewer) {
      this.a11yObserver?.disconnect();
      // Shopify model-viewer 1.12 has no public localization API. Keep this
      // adapter scoped to its accessibility nodes; do not replace the library.
      const locale=(document.documentElement.lang || 'en').split('-')[0];
      const copy={
        sv:['Använd musen, pekskärmen eller piltangenterna för att rotera.','Laddar 3D-modell','Visa i ditt rum','Avsluta AR','Statusmeddelanden','Vy','framifrån','från höger','bakifrån','från vänster','ovanifrån','underifrån'],
        en:['Use mouse, touch or arrow keys to move.','Loading 3D model','View in your space','Exit AR','Live announcements','View','from the front','from the right','from the back','from the left','from above','from below'],
        de:['Mit Maus, Touchscreen oder Pfeiltasten drehen.','3D-Modell wird geladen','In deinem Raum ansehen','AR beenden','Statusmeldungen','Ansicht','von vorne','von rechts','von hinten','von links','von oben','von unten'],
        fr:['Utilisez la souris, l’écran tactile ou les touches fléchées pour faire pivoter le modèle.','Chargement du modèle 3D','Voir dans votre espace','Quitter la RA','Messages d’état','Vue','de face','de droite','de dos','de gauche','du dessus','du dessous'],
        es:['Usa el ratón, la pantalla táctil o las flechas del teclado para girar el modelo.','Cargando modelo 3D','Ver en tu espacio','Salir de RA','Mensajes de estado','Vista','frontal','desde la derecha','trasera','desde la izquierda','desde arriba','desde abajo'],
        it:['Usa il mouse, il touchscreen o i tasti freccia per ruotare il modello.','Caricamento del modello 3D','Visualizza nel tuo spazio','Esci dalla RA','Messaggi di stato','Vista','frontale','da destra','posteriore','da sinistra','dall’alto','dal basso']
      }[locale];
      if (!copy) return;
      customElements.whenDefined('model-viewer').then(()=> {
        if(this.viewer!==viewer || !this.isConnected) return;
        const root=viewer.shadowRoot;
        if(!root) return;
        const translate=text=> {
          const fixed={'Loading':copy[1],'Loading 3D model':copy[1],'View in your space':copy[2],'Exit AR':copy[3],'Live announcements':copy[4]};
          if(fixed[text]) return fixed[text];
          const orientation=/^View from stage (upper-|lower-)?(front|right|back|left)$/.exec(text);
          if(orientation) return copy[5]+' '+copy[6+['front','right','back','left'].indexOf(orientation[2])]+(orientation[1]?', '+copy[orientation[1]==='upper-'?10:11]:'');
          return text.replace('Use mouse, touch or arrow keys to move.',copy[0]);
        };
        const update=()=> {
          root.querySelectorAll('[aria-label]').forEach(el=>{const old=el.getAttribute('aria-label'),next=translate(old);if(old!==next)el.setAttribute('aria-label',next);});
          const status=root.querySelector('#status');
          if(status){const old=status.textContent,next=translate(old);if(old!==next)status.textContent=next;}
        };
        this.a11yObserver=new MutationObserver(update);
        this.a11yObserver.observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label']});
        update();
      });
    }
    addTools() {
      this.tools?.remove();
      const stage=this.host.querySelector('[data-stage]') || this.viewer.closest('product-model') || this.viewer.parentElement;
      stage.style.position='relative';
      this.tools=document.createElement('div');this.tools.className='wf-viewer-tools';
      for(const [key,label,symbol] of [['in',this.dataset.zoomIn,'+'],['out',this.dataset.zoomOut,'−'],['reset',this.dataset.reset,'↺'],['fullscreen',this.dataset.fullscreen,'']]) {
        const b=document.createElement('button');b.type='button';b.dataset.cameraAction=key;b.textContent=symbol;b.setAttribute('aria-label',label);b.title=label;if(key==='fullscreen'){b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 3H3v5M16 3h5v5M21 16v5h-5M8 21H3v-5"/></svg>';b.setAttribute('aria-pressed','false');}
        b.addEventListener('click',()=>key==='fullscreen'?this.toggleFullscreen():key==='reset'?this.select('all'):this.zoom(key==='in'?.8:1.25),{signal:this.controller.signal});this.tools.append(b);
      }
      this.tools.addEventListener('pointerup',e=>e.stopPropagation(),{signal:this.controller.signal});stage.append(this.tools);
    }
    updateTourButton() {
      const b=this.tourButton;if(!b)return;
      if(this.isOrbitTour())b.style.display=this.reducedMotion?.matches?'none':'';
      const label=this.tourRunning?this.dataset.tourPause:this.tourIndex!=null?this.dataset.tourResume:this.dataset.tourPlay;
      b.setAttribute('aria-label',label);b.title=label;b.setAttribute('aria-pressed',String(!!this.tourRunning));
      b.querySelector('[data-tour-label]').textContent=label;
      b.querySelector('[data-tour-short]').textContent=this.tourRunning?this.dataset.tourPauseShort:this.tourIndex!=null?this.dataset.tourResumeShort:this.dataset.tourShort;
      b.querySelector('[data-tour-icon]').textContent=this.tourRunning?'Ⅱ':'▶';
      this.updateOrbitStatus();
    }
    stopTour() {
      this.hideOrbitHint();
      if(this.orbitFrame!=null||this.orbitAngle!=null){
        cancelAnimationFrame(this.orbitFrame);this.orbitFrame=null;
        if(this.tourRunning)this.freezeOrbitCamera();
        this.orbitAngle=null;
      }
      clearTimeout(this.tourTimer);this.tourTimer=null;this.restoreTourMotion();this.tourRunning=false;this.tourIndex=null;this.tourRemaining=null;this.updateTourButton();
    }
    toggleTour() {
      if(!this.viewer?.loaded)return;
      if(this.isOrbitTour()){this.toggleOrbitTour();return;}
      if(this.tourRunning){
        this.tourRemaining=Math.max(0,this.tourDeadline-performance.now());clearTimeout(this.tourTimer);this.tourTimer=null;this.tourRunning=false;
        // Freeze the in-flight camera as well as the sequence.
        const a=this.viewer.getCameraOrbit(),t=this.viewer.getCameraTarget();
        this.viewer.setAttribute('camera-orbit',`${a.theta}rad ${a.phi}rad ${a.radius}m`);
        this.viewer.setAttribute('camera-target',`${t.x}m ${t.y}m ${t.z}m`);
        this.viewer.setAttribute('field-of-view',`${this.viewer.getFieldOfView()}deg`);this.viewer.jumpCameraToGoal?.();this.restoreTourMotion();this.updateTourButton();return;
      }
      this.tourRunning=true;this.tourDecay=this.viewer.getAttribute('interpolation-decay');
      this.viewer.setAttribute('interpolation-decay','250');
      if(this.tourIndex==null){this.tourIndex=0;this.tourStep();}
      else {this.select(this.activeKey,true);this.scheduleTour(this.tourRemaining??3000);}
      this.updateTourButton();
    }
    initOrbitUI() {
      const language=(document.documentElement.lang||'en').split('-')[0];
      this.orbitCopy={
        sv:['Rundtur','Pausad rundtur','Dra för att ta över'],
        en:['Tour','Tour paused','Drag to take over'],
        de:['Rundgang','Rundgang pausiert','Ziehen, um selbst zu drehen'],
        fr:['Visite','Visite en pause','Faites glisser pour prendre la main'],
        es:['Recorrido','Recorrido en pausa','Arrastra para tomar el control'],
        it:['Tour','Tour in pausa','Trascina per prendere il controllo']
      }[language]||['Tour','Tour paused','Drag to take over'];
      this.orbitPausedShort={sv:'Pausad',en:'Paused',de:'Pausiert',fr:'En pause',es:'En pausa',it:'In pausa'}[language]||'Paused';
      if(this.mobileSelect){
        this.orbitOption=this.mobileSelect.querySelector('[data-orbit-status]');
        if(!this.orbitOption){
          this.orbitOption=document.createElement('option');
          this.orbitOption.value='orbit-tour';this.orbitOption.disabled=true;
          this.orbitOption.hidden=true;this.orbitOption.dataset.orbitStatus='';
          this.mobileSelect.append(this.orbitOption);
        }
      }
    }
    updateOrbitStatus() {
      if(!this.orbitOption)return;
      const touring=this.tourRunning||this.tourIndex!=null;
      if(touring){
        this.orbitOption.textContent=!this.tourRunning&&this.mobileSelect.clientWidth<170?this.orbitPausedShort:this.orbitCopy[this.tourRunning?0:1];
        this.mobileSelect.value='orbit-tour';
      }else if(this.mobileSelect.value==='orbit-tour'){
        this.mobileSelect.value=this.activeKey||'free';
      }
    }
    showOrbitHint() {
      if(!this.orbitCopy||this.orbitHintSeen)return;
      try{if(sessionStorage.getItem('wf:3d:orbit-hint-seen'))return;}catch(error){}
      const stage=this.host.querySelector('[data-stage]')||this.viewer?.closest('product-model')||this.viewer?.parentElement;
      if(!stage)return;
      this.orbitHintSeen=true;
      try{sessionStorage.setItem('wf:3d:orbit-hint-seen','1');}catch(error){}
      const hint=document.createElement('div');
      hint.className='wf-orbit-hint';hint.setAttribute('role','status');
      hint.textContent=this.orbitCopy[2];
      hint.style.cssText='position:absolute;top:10px;left:50%;transform:translateX(-50%);max-width:calc(100% - 24px);width:max-content;padding:5px 10px;border-radius:20px;background:rgba(255,255,255,.94);color:#444;font:12px/1.4 system-ui,sans-serif;text-align:center;pointer-events:none;z-index:2';
      this.orbitHint=hint;stage.append(hint);
      this.orbitHintTimer=setTimeout(()=>this.hideOrbitHint(),4200);
    }
    hideOrbitHint() {
      clearTimeout(this.orbitHintTimer);this.orbitHintTimer=null;
      this.orbitHint?.remove();this.orbitHint=null;
    }
    orbitDistance(angle) {
      const overview=parseFloat(this.fitDistance('all'));
      const fixedHost=this.closest('[data-fixed-tour]');
      if(fixedHost){
        const rect=this.viewer.getBoundingClientRect();
        const desktop=Number(fixedHost.dataset.desktopTourDistance);
        return (rect.width>=rect.height&&desktop>=overview&&desktop<=150?desktop:overview)+'%';
      }
      const size=this.viewer.getDimensions();
      const endView=size.x>=size.z?Math.sin(angle)**2:Math.cos(angle)**2;
      const endDistance=Number(this.closest('[data-desktop-orbit-end]')?.dataset.desktopOrbitEnd);
      const rect=this.viewer.getBoundingClientRect();
      if(rect.width>=rect.height&&endDistance>=overview&&endDistance<=150)return (overview+(endDistance-overview)*endView).toFixed(3)+'%';
      const approach=this.dataset.profile==='bike'?.06:.025;
      return (overview*(1-approach*endView)).toFixed(3)+'%';
    }
    isOrbitTour() {
      // Shared standard for the inventoried product viewers using this component.
      return true;
    }
    freezeOrbitCamera() {
      const v=this.viewer;if(!v?.loaded)return;
      const a=v.getCameraOrbit(),t=v.getCameraTarget();
      v.setAttribute('camera-orbit',`${a.theta}rad ${a.phi}rad ${a.radius}m`);
      v.setAttribute('camera-target',`${t.x}m ${t.y}m ${t.z}m`);
      v.setAttribute('field-of-view',`${v.getFieldOfView()}deg`);
      v.jumpCameraToGoal?.();
    }
    toggleOrbitTour() {
      if(this.reducedMotion?.matches)return;
      if(this.tourRunning){
        this.hideOrbitHint();
        cancelAnimationFrame(this.orbitFrame);this.orbitFrame=null;
        this.freezeOrbitCamera();this.orbitAngle=this.viewer.getCameraOrbit().theta;
        this.tourRunning=false;this.restoreTourMotion();this.updateTourButton();return;
      }
      const v=this.viewer;
      this.orbitAngle=v.getCameraOrbit().theta;
      this.tourIndex=0;this.tourRunning=true;this.zoomGoalRadius=null;
      this.tourDecay=v.getAttribute('interpolation-decay');
      v.setAttribute('interpolation-decay','180');
      v.setAttribute('camera-target',this.initial.target);
      v.setAttribute('field-of-view',this.initial.fov);
      if(this.helpPanel)this.helpPanel.open=false;
      this.mark('free');this.updateTourButton();this.showOrbitHint();
      let previous=null,elapsed=0;
      const frame=now=>{
        if(!this.tourRunning)return;
        if(!this.isConnected||document.hidden||!v.loaded){this.stopTour();return;}
        // Integrate elapsed time, not frame count. Clamp long gaps to avoid jumps.
        const dt=previous===null?0:Math.min((now-previous)/1000,.1);
        previous=now;elapsed+=dt;
        const ramp=Math.min(1,elapsed/1.5);
        const speed=24*Math.PI/180*(ramp*ramp*(3-2*ramp));
        this.orbitAngle+=speed*dt;
        // Restrained, model-axis-aware approach at end views, continuous at 360°.
        // Fixed elevation and target; the base distance remains aspect-aware.
        v.setAttribute('camera-orbit',`${this.orbitAngle}rad 78deg ${this.orbitDistance(this.orbitAngle)}`);
        this.orbitFrame=requestAnimationFrame(frame);
      };
      this.orbitFrame=requestAnimationFrame(frame);
    }
    restoreTourMotion() {
      if(this.tourDecay!==undefined&&this.viewer){if(this.tourDecay===null)this.viewer.removeAttribute('interpolation-decay');else this.viewer.setAttribute('interpolation-decay',this.tourDecay);this.tourDecay=undefined;}
    }
    scheduleTour(delay) {
      this.tourDeadline=performance.now()+delay;
      this.tourTimer=setTimeout(()=>{this.tourIndex++;this.tourStep();},delay);
    }
    tourStep() {
      if(!this.tourRunning||!this.viewer?.loaded)return;
      const sequence=[['all',2500],['right',3500],['display',5000],['frame',4500],[this.dataset.profile==='bike'?'battery':'deck',4500],['left',3500],['all',2500]];
      if(this.tourIndex>=sequence.length){this.stopTour();return;}
      const [key,duration]=sequence[this.tourIndex];this.select(key,true);this.scheduleTour(duration);
    }
    updateZoomButtons() {
      if(!this.viewer?.loaded||!this.tools)return;
      const radius=this.zoomGoalRadius??this.viewer.getCameraOrbit().radius;
      this.tools.querySelector('[data-camera-action=in]').disabled=radius<=this.minRadius*1.005;
      this.tools.querySelector('[data-camera-action=out]').disabled=radius>=this.maxRadius*.995;
    }
    detailDistance(distance) {
      const r=this.viewer.getBoundingClientRect();
      // Protect horizontal detail framing on portrait viewports.
      return distance*Math.max(1,.8/Math.max(.25,r.width/r.height));
    }
    mobileDetailDistance(key,distance) {
      const r=this.viewer.getBoundingClientRect();
      const raw=this.closest(`[data-camera-mobile-${key}-distance]`)?.getAttribute(`data-camera-mobile-${key}-distance`);
      const configured=Number(raw);
      return r.width<r.height&&configured>=.12&&configured<=3?configured:this.detailDistance(distance);
    }
    setExpanded(value){
      this.expanded=value;this.fullscreenHost?.classList.toggle('wf-viewer-expanded',value);
      const b=this.tools?.querySelector('[data-camera-action="fullscreen"]');if(b){const label=value?this.dataset.exitFullscreen:this.dataset.fullscreen;b.title=label;b.setAttribute('aria-label',label);b.setAttribute('aria-pressed',String(value));}
    }
    async toggleFullscreen(){
      if(this.expanded){await this.exitFullscreen();return;}
      this.setExpanded(true);
      // A modal dialog lives in the top layer. Fullscreening its ancestor can hide it
      // behind the fullscreen backdrop; dialogs themselves cannot request fullscreen.
      // Keep its viewport-filling mode, including on browsers without Fullscreen API.
      if(this.fullscreenHost.tagName==='DIALOG')return;
      try{if(this.fullscreenSurface.requestFullscreen&&document.fullscreenEnabled){await this.fullscreenSurface.requestFullscreen();this.nativeFullscreen=document.fullscreenElement===this.fullscreenSurface;}}catch(error){/* Keep the expanded viewer when native fullscreen is unavailable. */}
    }
    async exitFullscreen(){
      if(document.fullscreenElement===this.fullscreenSurface){try{await document.exitFullscreen();}catch(error){}}
      this.nativeFullscreen=false;this.setExpanded(false);
    }
    fitDistance(key) {
      const r=this.viewer.getBoundingClientRect();
      if(this.closest('[data-model-layout="falcongt"],[data-model-layout="lynx"]')){
        if(key==='all'&&r.width<600)return '96%';
        if(['right','left','front','rear'].includes(key))return r.width<600?'102%':(['front','rear'].includes(key)?'96%':'78%');
      }
      const mobileOverview=Number(this.closest('[data-mobile-overview]')?.dataset.mobileOverview);
      const desktopOverview=Number(this.closest('[data-desktop-overview]')?.dataset.desktopOverview);
      if(key==='all'&&r.width>=r.height&&desktopOverview>=60&&desktopOverview<=100)return desktopOverview+'%';
      if(key==='all'&&r.width<r.height&&mobileOverview>=60&&mobileOverview<=100)return mobileOverview+'%';
      // Percentage distances use model-viewer's own aspect-aware framing.
      return this.host.closest('product-modal')&&r.width<r.height?'110%':'100%';
    }
    zoom(factor) {
      this.stopTour();
      const v=this.viewer;if(!v?.loaded)return;const a=v.getCameraOrbit();
      const radius=Math.min(this.maxRadius,Math.max(this.minRadius,(this.zoomGoalRadius??a.radius)*factor));this.zoomGoalRadius=radius;
      v.setAttribute('camera-orbit',`${a.theta}rad ${a.phi}rad ${radius}m`);this.mark('free');
      this.tools.querySelector('[data-camera-action=in]').disabled=radius<=this.minRadius*1.005;this.tools.querySelector('[data-camera-action=out]').disabled=radius>=this.maxRadius*.995;
      if(matchMedia('(prefers-reduced-motion: reduce)').matches)v.jumpCameraToGoal?.();
    }
    mark(key) { this.activeKey=key;if(this.mobileSelect)this.mobileSelect.value=key; this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===key))); }
    select(key,fromTour=false) {
      if(!fromTour)this.stopTour();
      const v=this.viewer;if(!v || this.buttons.find(b=>b.dataset.view===key)?.disabled)return;
      if(this.helpPanel)this.helpPanel.open=false;this.zoomGoalRadius=null;
      const d=v.getDimensions(),c=this.center;
      const bike=this.dataset.profile==='bike';
      // glTF Y is vertical. Targets are scaled to this model's actual bounds.
      const height=d.y,front=c.x-d.x*(bike?.36:.30);
      const calibrated=cameraProfiles[this.closest(Object.keys(cameraProfiles).join(','))?.tagName.toLowerCase()]||(this.host.closest('product-modal')?cameraProfiles['product-model']:{});
      const targets={
        right:{target:[c.x,c.y,c.z],orbit:'180deg 78deg 95%'},
        left:{target:[c.x,c.y,c.z],orbit:'0deg 78deg 95%'},
        display:{target:[c.x-d.x*(bike?.28:.16),c.y+height*.43,c.z],orbit:`90deg 38deg ${height*.48}m`},
        frame:{target:[front,c.y-height*(bike?.05:.27),c.z],orbit:`-35deg 65deg ${height*(bike?.85:.65)}m`},
        deck:{target:[c.x,c.y-height*.30,c.z],orbit:`55deg 32deg ${height*1.10}m`},
        battery:{target:[c.x,c.y-height*.06,c.z],orbit:`-25deg 70deg ${height*.9}m`}
      };
      
      for(const key of ['display','battery','frame'])if(calibrated[key])targets[key].target=calibrated[key];
      for(const key of ['display','battery','frame']){
        const raw=this.closest(`[data-camera-${key}]`)?.getAttribute(`data-camera-${key}`);
        const override=raw?.split(',').map(Number);
        if(override?.length===3&&override.every(Number.isFinite))targets[key].target=override;
      }
      // iX7 steering-neck close-up, checked against its fork reference.
      if(this.closest('wf-ix7-3d'))targets.frame={target:[c.x-d.x*.30,c.y-height*.27,c.z],orbit:`-25deg 78deg ${height*.50}m`};
      if(this.dataset.profile==='wheelchair'){
        targets.right={target:[c.x,c.y,c.z],orbit:'180deg 78deg 100%'};
        targets.left={target:[c.x,c.y,c.z],orbit:'0deg 78deg 100%'};
        targets.front={target:[c.x,c.y,c.z],orbit:'-90deg 78deg 100%'};
        targets.rear={target:[c.x,c.y,c.z],orbit:'90deg 78deg 100%'};
        targets.display={target:[-.330,.761,-.247],orbit:'70deg 38deg .42m'};
        targets.frame={target:[.065,.79,0],orbit:'-45deg 66deg 1.70m'};
        targets.deck={target:[-.40,.22,0],orbit:'-45deg 48deg 1.12m'};
        targets.motor={target:[.33,.13,0],orbit:'135deg 67deg 1.30m'};
        targets.headrest={target:[.30,1.00,0],orbit:'45deg 70deg .64m'};
        targets.battery={target:[.06,.43,0],orbit:'115deg 78deg .68m'};
      }
      // C20 geometry: standard mesh back (no headrest), two batteries and lower controls.
      if(this.closest('[data-model-layout="c20"]')){
        targets.display={target:[-.324,.703,-.250],orbit:'70deg 38deg .64m'};
        targets.frame={target:[.015,.69,0],orbit:'-135deg 64deg 1.40m'};
        targets.deck={target:[-.38,.17,0],orbit:'-135deg 48deg 1.00m'};
        targets.motor={target:[.27,.14,0],orbit:'135deg 68deg 1.13m'};
        targets.battery={target:[-.02,.34,0],orbit:'-70deg 78deg .94m'};
      }
      // C30: upholstered back, split footrests and one external right-side battery.
      if(this.closest('[data-model-layout="c30"]')){
        targets.display={target:[-.324,.703,-.250],orbit:'70deg 38deg .64m'};
        targets.frame={target:[.005,.66,0],orbit:'-135deg 64deg 1.40m'};
        targets.deck={target:[-.39,.20,0],orbit:'-135deg 48deg 1.00m'};
        targets.motor={target:[.25,.16,0],orbit:'135deg 68deg 1.13m'};
        targets.battery={target:[-.04,.34,-.24],orbit:'-180deg 78deg .84m'};
      }
      // F10: oval controls, broad footplate and rear removable battery case.
      if(this.closest('[data-model-layout="f10"]')){
        targets.display={target:[-.240,.678,-.252],orbit:'70deg 20deg .46m'};
        targets.frame={target:[.010,.635,0],orbit:'-135deg 64deg 1.20m'};
        targets.deck={target:[-.390,.14,0],orbit:'-135deg 46deg .76m'};
        targets.motor={target:[.285,.13,0],orbit:'135deg 68deg .90m'};
        targets.battery={target:[.305,.185,0],orbit:'90deg 58deg .92m'};
      }
      // Falcon GT: actual mid-drive chassis and rider-facing instrument.
      if(this.closest('[data-model-layout="falcongt"]')){
        targets.front={target:[c.x,c.y,c.z],orbit:'-90deg 78deg 95%'};
        targets.rear={target:[c.x,c.y,c.z],orbit:'90deg 78deg 95%'};
        targets.display={target:[-.313,1.038,0],orbit:'90deg 38deg .82m'};
        targets.frame={target:[-.495,.620,0],orbit:'-60deg 78deg 1.80m'};
        targets.deck={target:[.255,.565,0],orbit:'45deg 82deg 1.04m'};
        targets.motor={target:[.375,.405,-.040],orbit:'155deg 77deg 1.44m'};
        targets.battery={target:[-.07,.68,0],orbit:'-35deg 65deg 1.18m'};
      }
      if(this.closest('[data-model-layout="lynx"]')){
        targets.front={target:[c.x,c.y,c.z],orbit:'-90deg 78deg 95%'};
        targets.rear={target:[c.x,c.y,c.z],orbit:'90deg 78deg 95%'};
        targets.display={target:[-.320,1.070,0],orbit:'90deg 38deg .80m'};
        targets.frame={target:[-.495,.650,0],orbit:'-60deg 78deg 1.75m'};
        targets.deck={target:[.180,.660,0],orbit:'45deg 78deg 1.03m'};
        targets.motor={target:[.290,.395,-.06],orbit:'155deg 77deg 1.52m'};
        targets.battery={target:[-.11,.68,0],orbit:'-35deg 70deg 1.30m'};
      }
      if(key==='all'){
        const a=this.initial.angles;const overviewOrbit=`${a.theta}rad ${a.phi}rad ${this.fitDistance(key)}`;
        v.setAttribute('camera-target',this.initial.target);v.setAttribute('camera-orbit',overviewOrbit);v.setAttribute('field-of-view',this.initial.fov);
      } else {
        const p=targets[key];if(!p)return;
        v.setAttribute('camera-target',p.target.map(x=>x+'m').join(' '));const orbit=(['right','left','front','rear'].includes(key))?p.orbit.replace('95%',this.fitDistance(key)):p.orbit.replace(/([\d.]+)m$/,(_,radius)=>`${this.mobileDetailDistance(key,Number(radius))}m`);v.setAttribute('camera-orbit',orbit);v.setAttribute('field-of-view',['right','left','front','rear'].includes(key)?this.initial.fov:'30deg');
      }
      if(matchMedia('(prefers-reduced-motion: reduce)').matches) v.jumpCameraToGoal?.();
      this.mark(key);
    }
  });
}
